import React from 'react';
import TestResult from './TestResult';
import axios from 'axios';

import * as Globals from './../Globals';


export default class Test extends React.Component {

    constructor(props) {
        super(props);

        this.questionCount = 0;
        this.needRefill = false;
        this.questionIDs = [];
        this.testResultIDs = [];
        this.testID = this.props.id;
        this.state = {
            date: "",
            key: "",
            subjects: [],
            testResults: [],
            showResults: false,
            editQuestions: false,
            showKey: false,
            questions: []
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'test/' + this.testID + '?Authentication=' + cookie
        ).then(response => {
            this.setState({
                date: response.data.records[0].expire_date,
                key: response.data.records[0].access_key
            });
            this.questionCount = response.data.records[0].question_number;
        }).catch((error) => {
            this.props.CheckAuthError(error);
        });
        axios.get(Globals.EL_PATH + 'test/' + this.testID + '/subject?Authentication=' + cookie
        ).then((response) => {
            this.setState({
                subjects: response.data.records
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
            if (error.response.data.message !== "No test_subject found.") {
            }
        });
        this.initTestresults();
        this.initQuestions();
    }

    initTestresults() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'test/' + this.testID + '/testresult?Authentication=' + cookie
        ).then((response) => {
            this.setState({
                testResults: response.data.records
            });
            this.testResultIDs = [];
            response.data.records.map(result => {
                this.testResultIDs.push(result.id);
                return null;
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
            if (error.response.data.message !== "No testresults found.")
                this.testResultIDs = [];
        });
    }

    handleViewProtocol(id, name, mark) {
        if (this.testResultIDs.indexOf(id) !== -1) {
            this.props.handleViewProtocol(id, this.state.date, name, mark);
        } else {
            this.initTestresults();
        }
    }

    getTestResults() {
        if (this.state.testResults.length !== 0) {
            return (
                <table className="table table-bordered margin-bottom-sm">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Bewertung</th>
                        <th className="text-center">Kontrolle</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.testResults.map((result) => {
                            return <TestResult key={result.id} CheckAuthError={this.props.CheckAuthError}
                                               LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} id={result.id}
                                               userID={result.users_id} is_unlocked={result.is_unlocked}
                                               mark={result.mark}
                                               sendViewProtocol={this.handleViewProtocol.bind(this)}/>
                        })
                    }
                    </tbody>
                </table>
            );
        } else {
            return (
                <p style={{"clear": "both"}} className="text-center">Es wurden keine Ergebnisse für diesen Test
                    gefunden.</p>
            );
        }
    }

    getResults() {
        if (this.state.showResults) {
            return (
                <div className="table-responsive margin-top-sm">
                    {this.getTestResults()}
                </div>
            );
        }
    }

    initQuestions() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + "test/" + this.testID + "/question?Authentication=" + cookie
        ).then((response) => {
            this.setState({
                questions: response.data.records
            });
            this.questionIDs = [];
            response.data.records.map(question => {
                this.questionIDs.push(question.id);
                return null;
            });
        }).catch((error) => {
            this.props.CheckAuthError(error);
            if (error.response.data.message === "No questions found.") {
                this.setState({
                    questions: []
                });
                this.questionIDs = [];
            } else {
            }
        });
    }

    deleteQuestion(index) {
        let cookie = this.props.LogoutOnCookieNotSet();
        if (this.questionIDs.indexOf(this.state.questions[index].id) !== -1) {
            let questions = this.state.questions;
            axios.delete(Globals.EL_PATH + "test/" + this.testID + "/question?Authentication=" + cookie, {
                data: {
                    QUESTION_ID: this.state.questions[index].id
                }
            }).catch(error => {
                this.props.CheckAuthError(error);
            });
            questions.splice(index, 1);
            this.setState({
                questions: questions
            });
            this.needRefill = true;
        } else {

            this.initQuestions();
        }
    }

    getQuestions() {
        if (this.state.questions.length === 0) {
            return (
                <p style={{"clear": "both"}} className="margin-top-sm text-center">Es wurden keine Fragen zu diesem Test
                    gefunden.</p>
            );
        } else {
            return (
                <div className="well well-sm margin-top-sm margin-bottom-sm">
                    <h4 className="text-center no-margin-top margin-bottom-md"><u>Fragen</u></h4>
                    {
                        this.state.questions.map((question, index) => {
                            return (
                                <div key={index}
                                     className={(index !== (this.state.questions.length - 1)) ? "margin-bottom-sm" : ""}>
                                    <h5 className="text-center no-margin">
                                        {question.text}
                                        <p className="btn btn-danger padding-xs removeIcon" type="button"
                                           onClick={() => this.deleteQuestion(index)}>
                                            <span className="glyphicon glyphicon-trash deleteQuestionButton"/>
                                        </p>
                                    </h5>
                                </div>
                            );
                        })
                    }
                </div>
            );
        }
    }

    showKey() {
        if (this.state.showKey) {
            return (
                <div className="container-fluid well well-sm key">
                    <button className="btn btn-link center-block" type="button"
                            onClick={() => this.setState({showKey: false})}> Teilnahmeschlüssel verbergen
                    </button>
                    <h5 className="text-center no-margin-top"><b>{this.state.key}</b></h5>
                </div>
            );
        } else {
            return (
                <button className="btn btn-link center-block" type="button"
                        onClick={() => this.setState({showKey: true})}> Teilnahmeschlüssel anzeigen </button>
            );
        }
    }

    refillQuestions() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.post(Globals.EL_PATH + "test/" + this.props.id + "/question?Authentication=" + cookie
        ).then(() => {
            this.initQuestions();
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    renderButtonSelection() {
        if (this.state.showResults) {
            return (
                <div>
                    {this.getResults()}
                    <button className="btn btn-default center-block margin-bottom-sm" type="button"
                            onClick={() => this.setState({showResults: false})}>Ergebnisse ausblenden
                    </button>
                </div>
            );
        } else if (this.state.editQuestions) {
            return (
                <div>
                    {this.getQuestions()}
                    {
                        (this.state.questions.length !== 0) ?
                            <div>
                                {
                                    (this.questionCount !== this.state.questions.length) ?
                                        <button className="btn btn-default float-right margin-bottom-sm" type="button"
                                                onClick={() => {
                                                    this.refillQuestions();
                                                }}>Fragen auffüllen</button> :
                                        <button className="btn btn-default float-right margin-bottom-sm" type="button"
                                                disabled>Fragen auffüllen</button>
                                }
                                <button className="btn btn-link float-left margin-bottom-sm" type="button"
                                        onClick={() => {
                                            this.setState({editQuestions: false});
                                        }}>Zurück
                                </button>
                            </div> :
                            <div>
                                <button className="btn btn-default center-left margin-bottom-sm" type="button"
                                        onClick={() => {
                                            this.setState({editQuestions: false});
                                        }}>Zurück
                                </button>
                                <button className="btn btn-default float-right margin-bottom-sm" type="button"
                                        onClick={() => {
                                            this.refillQuestions();
                                        }}>Fragen auffüllen
                                </button>
                            </div>
                    }
                </div>
            );
        } else {
            return (
                <div>
                    <button className="btn btn-default float-left margin-bottom-sm" type="button" onClick={() => {
                        this.setState({editQuestions: true})
                    }}>Fragen anzeigen
                    </button>
                    <button className="btn btn-default float-right margin-bottom-sm" type="button"
                            onClick={() => this.setState({showResults: true})}>Ergebnisse anzeigen
                    </button>
                </div>
            );
        }
    }

    render() {
        return (
            <li className="list-group-item">
                <h4 className="text-center no-margin-bottom"><b>{this.state.date}</b>
                    {
                        this.state.subjects.map((subject, index) => {
                            if (index === 0) {
                                return (
                                    <span key={index}> - {subject.name}</span>
                                );
                            } else {
                                return (
                                    <span key={index}>, {subject.name}</span>
                                );
                            }
                        })
                    }
                </h4>
                {this.showKey()}
                {this.renderButtonSelection()}
            </li>
        );
    }

}



// WEBPACK FOOTER //
// ./src/admin/Test.js